import type { ReactNode } from 'react';
import { Separator } from './Separator';
import { SidebarTrigger } from './Sidebar';

interface HeaderLayoutProps {
  children?: ReactNode;
}

export default function HeaderLayout({
  children = 'DViO One',
}: HeaderLayoutProps) {
  return (
    <header className="flex items-center gap-2 transition-[width,height] ease-linear md:px-4 py-1 border-b h-16 sticky top-0 bg-background z-10">
      <div className="flex items-center w-fit gap-2">
        <SidebarTrigger />
        <Separator orientation="vertical" className="h-6" />
      </div>
      <div className="text-base lg:text-lg font-semibold flex-1">
        {children}
      </div>
    </header>
  );
}
